<template>
  <div>
    <user-actions-component :selected-filters="selectedFilters"></user-actions-component>
    <section class="bg-white py-5" aria-label="Favourites lists">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="2">
            <back-button></back-button>
          </b-col>
          <b-col sm="12" md="12" lg="8">
            <h1 class="mb-3">Favourite lists</h1>
            <b-list-group v-if="userFavouriteLists.length > 0">
              <b-list-group-item v-for="list in userFavouriteLists" :key="list.id" :value="list.id"
                ><router-link
                  :to="{
                    name: 'Favourite List',
                    params: {
                      id: list.id,
                        name: encodeURI(list.title), // eslint-disable-line
                    },
                  }"
                  aria-label="View List"
                  itemprop="url"
                >
                  {{ list.title }}
                </router-link>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import { FavouriteCall } from '@/common/api.service'
import BackButton from '../elements/BackButton.vue'
import UserActionsComponent from '../elements/UserActionsComponent.vue'

export default {
  name: 'FavouriteDisplayLists',
  components: {
    BackButton,
    UserActionsComponent,
  },
  data() {
    return {
      itemId: '',
      itemName: '',
      itemList: '',
      userFavouriteLists: [],
      favouriteList: [],
    }
  },
  mounted() {
    this.getuserFavouriteLists()
  },
  methods: {
    async getuserFavouriteLists() {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_lists',
      })
      this.userFavouriteLists = data
    },
    async displayFavouriteList() {
      const { data } = await FavouriteCall.post({
        req_id: 'get_user_favourite_list_by_id',
        list_id: this.itemList,
      })
      this.favouriteList = data
    },
  },
}
</script>
